import baseAPI from '@/http'

const router = 'api/salaindicadorapuracao'

export const salaIndicadorApuracao = {
  create: (apuracao) => baseAPI.post(router, apuracao),
  update: (apuracao) => baseAPI.put(router, apuracao),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
